import { Badge } from '@/components/shadcn/badge'
import { cn } from '@/lib/utils'
import { UserLinkedProject } from '../useUserLinkedProjects'

export function getProjectsSidebarItemId(projectId: number) {
  return `projects-sidebar-item-${projectId}`
}

export function ProjectsSidebarItem({
  project,
  isSelected,
  onSelect,
}: {
  project: UserLinkedProject
  isSelected: boolean
  onSelect: (projectId: number) => void
}) {
  const { projectId, name, isFrozen, workspaces } = project

  return (
    <button
      type="button"
      id={getProjectsSidebarItemId(projectId)}
      onClick={() => onSelect(projectId)}
      className={cn(
        'relative flex h-9 w-full min-w-0 items-center rounded-md px-3 text-left text-sm outline-none transition-colors',
        'hover:bg-transparent hover:text-brand-hover focus-visible:ring-2 focus-visible:ring-ring',
        'first:mt-0'
      )}
    >
      {isSelected && (
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded bg-foreground/5">
          <div className="absolute left-0 top-[calc(50%-12px)] h-[24px] w-[4.5px] rounded-full bg-foreground" />
        </div>
      )}
      <div className="relative flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
        <span className={cn('min-w-0 flex-1 truncate font-light', isSelected && 'font-bold tracking-tighter')}>
          {name}
        </span>
        {isFrozen && (
          <Badge variant="info" className="shrink-0 px-1.5 py-0 text-2xs">
            Frozen
          </Badge>
        )}
        <Badge
          variant="outline"
          className="px-1.5 py-0 text-2xs"
          title={`${workspaces.length} workspace${workspaces.length === 1 ? '' : 's'}`}
        >
          {workspaces.length}
        </Badge>
      </div>
    </button>
  )
}
